<template>
  <WhitePage>
    <title-bar>その他</title-bar>
    <!-- <help-nav></help-nav> -->
    <h3>問い合わせ等</h3>
    <p>
      基本はツイッターの運営アカウント(@furanberry)にご連絡ください。
      メールでのご連絡も受け付けますが、返信はしない場合があります。メールアドレスは<span class="highlight">unmiracle-world@ten.kokage.cc</span>です。
    </p>
    <h3>募集について<div class="subtitle">砂場も大事な遊具なんです</div></h3>
    <p>
      運営に必要な要素のいくつかを募集しています。
      ご協力いただけたら泣いて喜びます。よろしくお願いします。
    </p>
    <h4>メインエリア背景画像</h4>
    <p>
      当ゲーム内のメインエリアの背景で使用します。
      採用された場合は、【アイコン枠拡張＋５枠】または【EP＋５】のいずれかのお礼をします。
    </p>
    <ul>
      <li>縦300px横1000pxのイラスト添付</li>
      <li>ENoとキャラクター名</li>
      <li>イラスト提供ページに記載するお名前</li>
      <li>希望のお礼（特になければEPになります）</li>
    </ul>
    <p>
      以上を添えて、メールにてお送りください。
    </p>
    <h4>NPC画像</h4>
    <p>
      当ゲーム内で出現するかもしれないNPCで使用します。
      採用された場合は、【アイコン枠拡張＋３枠】または【EP＋３】のいずれかのお礼をします。
    </p>
    <ul>
      <li>縦120px横120pxのアイコン１枚～５枚程度</li>
      <li>対象のNPC名</li>
      <li>ENoとキャラクター名</li>
      <li>イラスト提供ページに記載するお名前</li>
      <li>希望のお礼（特になければEPになります）</li>
    </ul>
    <p>
      以上を添えて、メールにてお送りください。
    </p>
    <!-- <h4>不奇跡世界ライブのイラスト</h4>
    <p>
      メニューの「<font-awesome-icon icon="tv" class="icon fa-1x" />」から見れる
      不奇跡世界の様子の中で、冒頭にイラストとして紹介します。
      採用された場合は【アイコン枠拡張＋３枠】または【EP＋３】のいずれかのお礼をします。
    </p>
    <ul>
      <li>縦600px以内横1000px以内のイラスト</li>
      <li>ENoとキャラクター名</li>
      <li>ライブ上に記載するお名前</li>
      <li>希望のお礼（特になければEPになります）</li>
    </ul>
    <p>
      以上を添えて、メールにてお送りください。
    </p> -->
    <h4>補足事項</h4>
    <p>
      恐縮ですが、選考の結果は、ゲーム内での採用をお返事とさせていただきます。
      また、忙しい時期のお礼の付与は時間がかかる可能性があります。
    </p>
    <pagenate>
      <template #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/help/game">ゲームルール</router-link>
      </template>
      <template #next>
        <router-link to="/special">提供</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
// import HelpNav from '@/components/HelpNav'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    WhitePage,
    TitleBar,
    // HelpNav
    Pagenate
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin: 2rem 10px 1.5rem;

  .subtitle {
    font-size: small;
    margin-left: 10px;
  }

}
p {
  margin: 0 10px 1rem;
}
.highlight {
  color: rgb(144, 24, 20);
}
</style>
